import { Link } from "react-router-dom";
import useApi, { LoadError } from "@/lib/useApi";
import useSEO from "@/hooks/useSEO";
import { PageHero, Reveal, AccessBadge, DemoTag, Empty } from "@/components/ui-lux";

export const CourseCard = ({ c, i = 0 }) => (
  <Reveal delay={i * 0.06}>
    <Link to={`/courses/${c.slug}`} className="group block" data-testid={`course-card-${c.slug}`}>
      <div className="relative rounded-2xl overflow-hidden aspect-[16/10]">
        <img src={c.cover_image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-4 left-4 flex gap-2"><AccessBadge access={c.access} /><DemoTag show={c.is_demo} /></div>
      </div>
      <h3 className="font-serif text-2xl font-semibold tracking-tight text-white mt-5 group-hover:text-gold-light transition-colors">{c.title}</h3>
      <p className="text-sm text-slate-400 mt-2 line-clamp-2">{c.description?.split("\n")[0]}</p>
      <p className="text-xs text-slate-500 mt-3 font-accent uppercase tracking-wider">
        {(c.modules || []).length} modules · {(c.modules || []).reduce((n, m) => n + (m.lessons || []).length, 0)} lessons
        {c.access === "paid" && c.price ? ` · $${c.price}` : ""}
      </p>
    </Link>
  </Reveal>
);

export default function Courses() {
  const { data: courses, error, reload } = useApi("/content/courses");
  useSEO({ title: "Online Courses", description: "Structured courses with modules, lessons and worksheets for lasting transformation." });
  return (
    <div data-testid="courses-page">
      <PageHero eyebrow="Courses" title="Structured paths to a renewed mind." sub="Step-by-step courses with video lessons, worksheets, quizzes and progress tracking." image="/images/todd-4738.jpg" />
      <div className="container-x">
        {error ? <LoadError onRetry={reload} /> : courses && !courses.length ? <Empty text="New courses are coming soon." /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">{(courses || []).map((c, i) => <CourseCard key={c.id} c={c} i={i} />)}</div>
        )}
      </div>
    </div>
  );
}
